const DEFAULT_BOOKING = "https://booking.rogersounds.com";

/**
 * URL сервісу бронювання з ?from_rs_site=1 — Vue booking не показує той самий holiday-попап.
 */
export function bookingUrlWithFromRsSite() {
  const base =
    (process.env.REACT_APP_BOOKING_URL || DEFAULT_BOOKING).replace(/\/$/, "") || DEFAULT_BOOKING;
  try {
    const u = new URL(base);
    u.searchParams.set("from_rs_site", "1");
    return u.toString();
  } catch {
    const sep = base.includes("?") ? "&" : "?";
    return `${base}${sep}from_rs_site=1`;
  }
}
